/* eslint-disable react/display-name */
import React from 'react';
import { iconSizer } from "../../icons2022/iconSizer";
import { XIcon20Light } from "../../icons2022/XIcon/XIcon20Light";
import { XIcon24Regular } from "../../icons2022/XIcon/XIcon24Regular";
export var CrossIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(XIcon20Light, {
      size: 16,
      align: "none"
    });
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(XIcon20Light, {
      align: "none"
    });
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(XIcon24Regular, {
      align: "none"
    });
  }
}, 'CrossIcon');